import React, { Component } from 'react';

export default class NotFound extends Component {
  /**
   * {@inheritdoc}
   */
  render() {
    return <p>Page non trouvée.</p>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/NotFound.js